import React from 'react';
import { Button } from 'components/Button';

const VairBanner = () => {
  return (
    <div className="relative mt-ds-xl flex items-center justify-between gap-4 overflow-hidden rounded-xl p-ds-xl">
      <img
        src="/images/vair/vair-banner-bg.gif"
        alt="VAIR Banner Background"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="z-10 flex items-center gap-ds-md">
        <img
          src="/images/vair/vair-white.png"
          alt="VAIR"
          className="h-10 w-auto object-contain max-sm:h-6 max-sm:w-auto"
        />
        <span className="max-sm:typography-product-card-title-mobile typography-informative-subheading text-color-text-lightmode-invert">
          Official Event
        </span>
      </div>
      {/* <Button isInline variant="primary-light" sizeMobile="md" className="z-10" sizeDesktop="sm">
        Learn More
      </Button> */}
    </div>
  );
};

export default VairBanner;
